// BIBL 品牌资源
import biblLogo from "./bibl/logo.png";
import biblSolidLogo from "./bibl/solidLogo.png";
import biblFavicon from "./bibl/favicon.png";

// 默认品牌资源
import defaultLogo from "./default/logo.png";
import defaultSolidLogo from "./default/solidLogo.png";
import defaultFavicon from "./default/favicon.png";

/**
 * 品牌资源映射表
 *
 * 包含所有租户的品牌资源（Logo、SolidLogo、Favicon）
 */
export const brandAssets = {
  bibl: {
    logo: biblLogo,
    solidLogo: biblSolidLogo,
    favicon: biblFavicon,
  },
  default: {
    logo: defaultLogo,
    solidLogo: defaultSolidLogo,
    favicon: defaultFavicon,
  },
} as const;

/**
 * 根据租户码获取品牌资源
 *
 * @param tenantCode - 租户码（如 "bibl"）
 * @returns 品牌资源对象（包含 logo、solidLogo 和 favicon）
 *
 * @example
 * const assets = getBrandAssets("bibl");
 * // => { logo: "/assets/bibl/logo.png", solidLogo: "/assets/bibl/solidLogo.png", favicon: "/assets/bibl/favicon.png" }
 */
export function getBrandAssets(tenantCode?: string) {
  console.log(tenantCode);
  
  if (tenantCode && tenantCode in brandAssets) {
    return brandAssets[tenantCode as keyof typeof brandAssets];
  }
  return brandAssets.default;
}
